/**
 * 시스템 > 장비관리 > 장비이동 컴포넌트 Store
 *
 * @since 2018-03-12
 * @author devp010
 */

export const state = () => ({
})

export const mutations = {
}

export const actions = {
}

export const getters = {
}

export const strict = false
